import {
  INIT,
  INIT_SUCCESS,
  INIT_FAILED,
  SET_FETCH_PARAMS,
  FETCH_SUCCESS,
  FETCH_FAILED,
  SELECT_DONATION,
  OPEN_OVERVIEW,
  CLOSE_OVERVIEW,
  MATCH_DONATIONS,
  MATCH_DONATIONS_SUCCESS,
  MATCH_DONATIONS_FAILED,
  UNMATCH_DONATIONS,
  UNMATCH_DONATIONS_SUCCESS,
  UNMATCH_DONATIONS_FAILED,
  CANCEL_CORPORATE_DONATION_FAILED,
  CANCEL_CORPORATE_DONATION_SUCCESS,
  CANCEL_CORPORATE_DONATION,
} from './constants';

export const initAction = () => ({
  type: INIT,
});
export const initSuccessAction = () => ({
  type: INIT_SUCCESS,
});
export const initFailedAction = (error) => ({
  type: INIT_FAILED,
  error,
});

export const fetchFailedAction = (error) => ({
  type: FETCH_FAILED,
  error,
});
export const fetchSuccessAction = (error) => ({
  type: FETCH_SUCCESS,
  error,
});

export const setFetchParamsAction = (params) => ({
  type: SET_FETCH_PARAMS,
  params,
});

export const selectDonationAction = (donationId) => ({
  type: SELECT_DONATION,
  donationId,
});

export const matchDonationsAction = (donationMatches) => ({
  type: MATCH_DONATIONS,
  donationMatches,
});
export const matchDonationsSuccessAction = (donationIds) => ({
  type: MATCH_DONATIONS_SUCCESS,
  donationIds,
});
export const matchDonationsFailedAction = (error) => ({
  type: MATCH_DONATIONS_FAILED,
  error,
});

export const unmatchDonationsAction = (donationIds) => ({
  type: UNMATCH_DONATIONS,
  donationIds,
});
export const unmatchDonationsSuccessAction = (donationIds) => ({
  type: UNMATCH_DONATIONS_SUCCESS,
  donationIds,
});
export const unmatchDonationsFailedAction = (error) => ({
  type: UNMATCH_DONATIONS_FAILED,
  error,
});

export const cancelCorporateDonationAction = (corporateDonation) => ({
  type: CANCEL_CORPORATE_DONATION,
  corporateDonation,
});
export const cancelCorporateDonationSuccessAction = (corporateDonation) => ({
  type: CANCEL_CORPORATE_DONATION_SUCCESS,
  corporateDonation,
});
export const cancelCorporateDonationFailedAction = (error) => ({
  type: CANCEL_CORPORATE_DONATION_FAILED,
  error,
});

export const openOverviewAction = () => ({
  type: OPEN_OVERVIEW,
});
export const closeOverviewAction = () => ({
  type: CLOSE_OVERVIEW,
});
